import React, {Component} from 'react';

import Button from '@material-ui/core/Button/index';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Checkbox from "@material-ui/core/Checkbox/index";
import FormGroup from "@material-ui/core/FormGroup/index";
import Slide from "@material-ui/core/Slide/index";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";

class ModalUsuarioEnviarReporte extends Component {
	
	
	render() {
		
		return (
			<div>
				
				<Dialog open={this.props.modal.open} onClose={() => this.props.closeModal()} disableEscapeKeyDown
				        disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				        PaperComponent={DraggableModal}
				>
					
					<DialogTitle>
						{this.props.modal.title} usuario enviar reporte
					</DialogTitle>
					
					<DialogContent>
						
						<article>
							
							<TextField
								select
								fullWidth
								onChange={this.props.handleChange}
								SelectProps={{
									native: true,
									MenuProps: {},
								}}
								
								name="id_cat_tipo_reporte"
								label="Tipo de reporte"
								value={this.props.form.id_cat_tipo_reporte}
								disabled={this.props.modal.tipo === 'view'}
							>
								<option value={''}>&nbsp;</option>
								{this.props.form.cat_tipo_reporte.map(option => (
									<option key={option.id_cat_tipo_reporte} value={option.id_cat_tipo_reporte}>
										{option.tipo_reporte}
									</option>
								))}
							</TextField>
							
							<TextField
								select
								fullWidth
								onChange={this.props.handleChange}
								SelectProps={{
									native: true,
									MenuProps: {},
								}}
								
								name="id_usuario"
								label="Usuario"
								value={this.props.form.id_usuario}
								disabled={this.props.modal.tipo === 'view'}
							>
								<option value={''}>&nbsp;</option>
								{this.props.form.cat_usuario_tipo_reporte.map(option => (
									<option key={option.id_usuario} value={option.id_usuario}>
										{option.nombre} {option.apellido_paterno} {option.apellido_materno}
									</option>
								))}
							</TextField>
							
							<FormGroup row className={'margin-3-L'}>
								<FormControlLabel
									control={
										<Checkbox type="checkbox" name='activo' checked={this.props.form.activo}
										          onChange={this.props.handleChange} value="activo" color="primary"
										          disabled={this.props.modal.tipo === 'view'}/>
									}
									label={'Activo'}
								/>
							</FormGroup>
						
						</article>
					
					</DialogContent>
					
					<DialogActions>
						
						<Button onClick={() => this.props.closeModal()} color="primary">
							{this.props.modal.tipo === 'view' ? 'Cerrar' : 'Cancelar'}
						</Button>
						
						{this.props.modal.tipo !== 'view' ? (
							<Button onClick={() => this.props.save()} color="primary">
								{this.props.form.id_usuario_enviar_reporte > 0 ? 'Actualizar' : 'Agregar'}
							</Button>
						) : ''}
					
					</DialogActions>
				
				</Dialog>
			
			
			</div>
		);
	}
}

export default ModalUsuarioEnviarReporte;
